import { render, staticRenderFns } from "./Nomore.vue?vue&type=template&id=4f7e3b12&scoped=true&"
import script from "./Nomore.vue?vue&type=script&lang=js&"
export * from "./Nomore.vue?vue&type=script&lang=js&"
import style0 from "./Nomore.vue?vue&type=style&index=0&id=4f7e3b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e3b12",
  null
  
)

export default component.exports